import React from 'react';
import MediaThumbnailProps, { MediaPlayIconProps } from "./props";
import "./styles.scss";

import Icon from '../../private/Icon';

import playVideoIcon from '../../../icons/play_video.svg';
import immersiveIcon from '../../../icons/immersive.svg';
import image360Icon from '../../../icons/360photo.svg';

const icons: Record<string, string> = {
  video: playVideoIcon,
  immersive: immersiveIcon,
  image360: image360Icon
}

const iconClassNames = { s36: true };

function PlayIcon(props: MediaPlayIconProps) {
  if (props?.icon) {
    return props.icon;
  }

  const svg = props?.svg || 'video';
  const iconSvg = icons[svg] || svg;
  const e2e = props?.e2e || 'media-icon';
  
  return (
    <div className="media-thumbnail__icon">
      <Icon svg={ iconSvg } classNames={ iconClassNames } alt={props.label} e2e={e2e} />
    </div>
  );
}


function MediaThumbnail(props: MediaThumbnailProps) {
  const { image, icon, label, noMedia = false } = props;

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    props?.onClick && props.onClick(e);
  };

  const style = {
    ...(image && { backgroundImage: `url(${image})` })
  };

  const overlayClasses = ['media-thumbnail__overlay'];
  if (props?.hover) {
    overlayClasses.push('media-thumbnail__overlay_hover')
  }
  const overlayClassName = overlayClasses.join(' ');

  return (
    <div className={`media-thumbnail ${noMedia ? 'no-media' : ''}`} style={ style } onClick={ handleClick }>
      {!noMedia && (<div className={ overlayClassName } />)}

      <div className="media-thumbnail__content">
        {!noMedia && (
          <PlayIcon icon={ icon } svg={ props?.svg } label={ props.label } e2e={ props?.e2e } />
        )}
        { label && <span className='media-thumbnail__label'>{ label }</span> }
      </div>
    </div>
  );
}

export default React.memo(MediaThumbnail);
